module.exports = __webpack_public_path__ + "static/media/anchor.48ad62c1.svg";